import Datatable from "./presentation/DataTable"

export default Datatable;